import { useCallback, useEffect } from "react";
import api from "../api";
import useSettingsStore from "../store/settings";

/**
 * Custom hook to fetch settings from backend.
 * @param {boolean} autoFetch - Whether to automatically fetch settings on mount
 * @returns {Object} An object containing the refresh function
 */
const useInitSettings = (autoFetch = true): { refreshSettings: () => Promise<void> } => {
  const [setSettings] = useSettingsStore(state => [state.setSettings]);

  const fetchSettings = useCallback(async () => {
    const settings = await api.getSettings();
    if (!settings) {
      return;
    }

    setSettings(settings);
  }, [setSettings]);

  useEffect(() => {
    if (autoFetch) {
      fetchSettings();
    }
  }, [autoFetch, fetchSettings]);

  return {
    refreshSettings: fetchSettings,
  };
};

export default useInitSettings;
